import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import ThemesPanel from '../../../../components/Editor/EditPanel/ThemesPanel';


const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			themes,
			selectedThemeId,
		},
	} = state;

	return {
		themes,
		selectedThemeId,
	};
};

export default connect(mapStateToProps)(ThemesPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/ThemesPanel/index.tsx